import { deviceSize } from 'lib/constants/GridBreakpoints'
import { KnowunityNumbers } from 'lib/constants/KnowunityNumbers'
import { parseTranslationInterpolation } from 'lib/features/translation'
import _useTranslation from 'lib/hooks/_useTranslation'
import { Body2, Headline2, Headline5 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import RotatingReviews from 'stories/V1/sections/RotatingReviews'
import styled from 'styled-components'
import StarIcon from 'assets/homepage-redesign/star.svg'
import Row from 'components/elements/Row'

const ReviewsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #061c31;
    border-radius: 48px;
    padding: 75px 0 50px;
    max-width: 100vw;
    @media (max-width: 740px) {
        padding: 40px 0 25px;
        gap: 0px;
        border-radius: ${theme.borderRadius.rounded};
    }
    h2 {
        padding: 0 20% !important;
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 36px;
        line-height: 40px;
        letter-spacing: -0.8px;
        span {
            all: inherit;
            padding: 0px;
            display: inline;
            color: #797fdd;
        }
        @media (max-width: 740px) {
            padding: 0px 10% !important;
            font-family: var(--font-inter);
            font-weight: 650;
            font-size: 23px;
            line-height: 28px;
            letter-spacing: -0.2px;
        }
    }
    .store-reviews {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding: 24px;
        @media (max-width: 740px) {
            gap: 8px;
            padding: 24px 24px 0px 24px;
        }
        .store-review-item {
            position: relative;
            display: flex;
            align-items: center;
            gap: 8px;
            background-color: ${theme.colors.backgroundTransparent};
            border-radius: 24px;
            padding: 14px 18px 14px 8px;
            & > div {
                position: relative;
                left: -5px;
            }
            svg {
                position: relative;
                left: 5px;
                scale: 0.7;
            }

            h5 {
                color: ${theme.colors.white};
                font-size: 20px;
                line-height: 24px;
                font-weight: 650;
                letter-spacing: 0px;
                margin: 0;
                span {
                    all: inherit;
                    display: inline-block;
                    padding: 0 4px;
                    color: ${theme.colors.sunlightYellow};
                }
            }

            p {
                color: ${theme.colors.grayScaleSecondary};
                font-size: 14px;
                font-weight: 450;
                line-height: 20px;
                letter-spacing: 0.4px;
                margin: 0;
            }
            @media ${deviceSize.md} {
                flex-direction: column;
                width: 100%;
                padding: 8px 16px;
                gap: 0px;
                p {
                    font-size: 14px;
                }
            }
        }
    }
`

const StyledSpan = styled.span`
    padding: 0px;
    display: inline;
    margin: 0px;
`

const StudentReviews = () => {
    const { t } = _useTranslation('homepage')

    const topReviews = [
        {
            name: t(`homepage/topPositiveReviewUser1`),
            text: t(`homepage/topPositiveReviewText1`),
            stars: 5,
        },
        {
            name: t(`homepage/topPositiveReviewUser2`),
            text: t(`homepage/topPositiveReviewText2`),
            stars: 5,
        },
        {
            name: t(`homepage/topPositiveReviewUser3`),
            text: t(`homepage/topPositiveReviewText3`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser1`),
            text: t(`homepage/newPositiveReviewText1`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser2`),
            text: t(`homepage/newPositiveReviewText2`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser3`),
            text: t(`homepage/newPositiveReviewText3`),
            stars: 5,
        },
        {
            name: t(`homepage/bottomPositiveReviewUser1`),
            text: t(`homepage/bottomPositiveReviewText1`),
            stars: 5,
        },
        {
            name: t(`homepage/bottomPositiveReviewUser2`),
            text: t(`homepage/bottomPositiveReviewText2`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser4`),
            text: t(`homepage/newPositiveReviewText4`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser5`),
            text: t(`homepage/newPositiveReviewText5`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser6`),
            text: t(`homepage/newPositiveReviewText6`),
            stars: 5,
        },
        {
            name: t(`homepage/newPositiveReviewUser7`),
            text: t(`homepage/newPositiveReviewText7`),
            stars: 5,
        },
    ]

    return (
        <ReviewsContainer>
            <Headline2
                textAlign="center"
                color={theme.colors.white}
                fontSize={30}
                fontFamily="var(--font-inter)"
                fontWeight={550}
            >
                {parseTranslationInterpolation(t('homepage/reviewsTitle'), [
                    {
                        index: 1,
                        component: StyledSpan,
                        props: {},
                    },
                ])}
            </Headline2>
            <div className="store-reviews">
                <div className="store-review-item">
                    <Row gap={3}>
                        <StarIcon />
                        <Headline5 fontFamily="var(--font-inter)">{KnowunityNumbers.appleReviewRating}/5</Headline5>
                    </Row>
                    <Body2 fontFamily="var(--font-inter)">{t('homepage/appleStore')}</Body2>
                </div>
                <div className="store-review-item">
                    <Row gap={3}>
                        <StarIcon />
                        <Headline5 fontFamily="var(--font-inter)">{KnowunityNumbers.googleReviewRating}/5</Headline5>
                    </Row>
                    <Body2 fontFamily="var(--font-inter)">{t('homepage/googlePlay')}</Body2>
                </div>
            </div>
            <RotatingReviews reviews={topReviews} />
        </ReviewsContainer>
    )
}

export default StudentReviews
